<template>
    <div>
        <DefaultMenu>
            <template #title>
                Declaraciones
            </template>
     
            <b-button
                v-permission="'family-menu-crear'"
                v-b-modal.createModalFamily
            >
                Crear <b-icon icon="journal-check" font-scale="1"></b-icon>
            </b-button>
            <b-button
                v-permission="'family-menu-notificaciones'"
                v-b-modal.notificacionesModalStatementFamily
                class="ms-1"
            >
                Notificaciones procesadas <b-icon icon="mailbox" font-scale="1"></b-icon>
            </b-button>
            <b-button
                v-permission="'family-menu-notificaciones'"
                v-b-modal.notificacionesModalAssignmentStatementFamily
                class="ms-1"
            >
                Plantillas asignadas <b-icon icon="people" font-scale="1"></b-icon>
            </b-button>
            <b-button
                v-permission="'family-menu-conflicts'"
                v-b-modal.conflictModalStatementFamily
                class="ms-1"
            >
                Conflictos <b-icon icon="exclamation-triangle" font-scale="1"></b-icon>
            </b-button>
            
            <template #right>
                <b-button
                    v-permission="'family-configuracion'"
                    @click="modalShowSetting = true"
                    title="Configuración"
                    v-b-tooltip.hover.left
                >
                    <b-icon icon="gear"/>
                </b-button>
            </template>
        </DefaultMenu>
        
        <BaseModal v-model="modalShowSetting" size="xl">
            <StatementSetting></StatementSetting>
        </BaseModal>

        <!-- Modal -->
        <b-modal
            v-model="modalShowCreate"
            hide-footer
            id="createModalFamily"
            title="Crear una declaración"
            size="xl"
            centered
            scrollable
            header-bg-variant="dark"
            class="m-0 p-0"
        >
            <template #modal-header="{ close }">
                <b-button size="sm" variant="outline-warning" @click="close">
                    Cerrar
                </b-button>
            </template>
            <StatementCreate></StatementCreate>
        </b-modal>

        <b-modal
            v-model="modalShowNotifications"
            hide-footer
            id="notificacionesModalStatementFamily"
            title="Notificaciones"
            size="xl"
            centered
            scrollable
            header-bg-variant="dark"
        >

            <template #modal-header="{ close }">
                <!-- Emulate built in modal header close button action -->
                <b-button size="sm" variant="outline-warning" @click="close">
                    Cerrar
                </b-button>

            </template>

            <StatementNotificationList></StatementNotificationList>

        </b-modal>

        <b-modal
            v-model="modalShowAssignmentNotifications"
            hide-footer
            id="notificacionesModalAssignmentStatementFamily"
            title="Notificaciones Asignaciones"
            size="xl"
            centered
            scrollable
            header-bg-variant="dark"
        >

            <template #modal-header="{ close }">
                <b-button size="sm" variant="outline-warning" @click="close">
                    Cerrar
                </b-button>

            </template>

            <StatementNotificationAssignmentList></StatementNotificationAssignmentList>

        </b-modal>

        <b-modal
            v-model="modalShowConflict"
            hide-footer
            id="conflictModalStatementFamily"
            title="Conflictos de Declaraciones"
            size="xl"
            centered
            scrollable
            header-bg-variant="dark"
        >
            <template #modal-header="{ close }">
                <b-button size="sm" variant="outline-warning" @click="close">
                    Cerrar
                </b-button>
            </template>
            <FamilyStatementConflictList></FamilyStatementConflictList>
        </b-modal>
    </div>
</template>
<script>
import DefaultMenu from '@/components/shared/Default-menu.vue'
import BaseModal from '@/components/shared/Base-modal.vue'
import StatementNotificationList from "@/components/FamilyStatements/FamilyStatementMenu/Family-statement-notification-list.vue";
import FamilyStatementConflictList from './FamilyStatementMenu/Family-statement-conflict-list.vue';
import StatementCreate from "@/components/FamilyStatements/FamilyStatementMenu/Family-statement-create.vue";
import StatementSetting from "@/components/FamilyStatements/FamilyStatementMenu/Family-statement-setting.vue";
import StatementNotificationAssignmentList from "@/components/FamilyStatements/FamilyStatementMenu/Family-statement-notification-assignment-list.vue";

export default {
    name: 'StatementsMenu',
    
    components: {
        StatementNotificationList,
        FamilyStatementConflictList,
        StatementCreate,
        DefaultMenu,
        StatementSetting,
        BaseModal,
        StatementNotificationAssignmentList
    },

    data() {
        return {
            modalShowCreate: false,
            modalShowNotifications: false,
            modalShowSetting: false,
            modalShowAssignmentNotifications: false,
            modalShowConflict: false
        }
    },
}
</script>